import React from 'react';
import { CpoOffersTypes } from '../types/offers';

interface GroupedItem {
  start: number;
  end: number;
  value: number;
}

type AccType = GroupedItem[];

const combineCpoOffers = (cpoOffers: CpoOffersTypes | null) => {
  if (!cpoOffers) return null;

  const grouped: { start: number; end: number; value: number }[] = Object.entries(cpoOffers)
    .filter(([key, value]) => {
      // Only APR keys with a number value
      return /^apr\d+_\d+$/.test(key) && typeof value === 'number';
    })
    .reduce(
      (acc, [key, value]) => {
        const rangeMatch = key.match(/apr(\d+)_(\d+)/)!;
        const start = parseInt(rangeMatch[1], 10);
        const end = parseInt(rangeMatch[2], 10);

        const existing = acc.find((item) => item.value === value && item.end + 1 === start);
        if (existing) {
          existing.end = end;
        } else {
          acc.push({ start, end, value: value as number }); // assert value is number
        }
        return acc;
      },
      [] as { start: number; end: number; value: number }[],
    );

  return grouped.reduce(
    (acc, { start, end, value }) => {
      acc[`apr${start}_${end}`] = value;
      return acc;
    },
    {} as Record<string, number>,
  );
};

export const rangeConverter = (rangeKey: string) => {
  const rangeMatch = rangeKey.match(/apr(\d+)_(\d+)/);
  if (!rangeMatch) return rangeKey;
  const start = parseInt(rangeMatch[1], 10);
  const end = parseInt(rangeMatch[2], 10);
  return `${start} - ${end}`;
};

export const formatOfferPercentage = (offerPercent: number | null): number | null => {
  if (offerPercent === null) {
    return null;
  }
  return Number((offerPercent * 100).toFixed(2));
};

export default combineCpoOffers;
